import icAddSquare from 'assets/images/ic-add-square.svg'
import icTrash from 'assets/images/ic-trash.svg'
import { Button } from 'avo-ui'
import ModalDelete from 'components/commons/modal-delete'
import Search from 'components/commons/search'
import Table from 'components/commons/table'
import { TABLE_CATEGORY_AWARD } from 'configs/award/configTableAwardCategory'
import { ACTION_TYPE } from 'constants/constant'
import { FormAwardCategory } from './FormAwardCategory'

export const AwardCategory = ({
    dataList,
    awardCategoryDetail,
    modal,
    setShowModal,
    query,
    onChangeQuery,
    isFormValid,
    optionsType,
    selectedIds,
    onSelectItemHandler,
    onActionRow,
    onChangeForm,
    onHideForm,
    onSubmit,
    onDelete,
    isLoading,
    isDeleting,
    isCreating,
    isUpdating,
    isResetSelectedItem,
}) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex gap-3 flex-wrap justify-between'}>
                <div className={'flex gap-x-3'}>
                    <Button
                        type={'outline'}
                        title={'Delete'}
                        icon={icTrash}
                        disabled={!selectedIds?.length}
                        onClick={() => onActionRow({ actionType: ACTION_TYPE.DELETE })}
                    />
                </div>
                <Button
                    type={'outline'}
                    icon={icAddSquare}
                    title={'Create Category Voting'}
                    onClick={() => onActionRow({ actionType: ACTION_TYPE.CREATE })}
                />
            </div>
            <Table
                className={'my-3'}
                name={TABLE_CATEGORY_AWARD.name}
                columns={TABLE_CATEGORY_AWARD.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onSelectItem={(val) => onSelectItemHandler(val)}
                onClickItem={onActionRow}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
                isResetSelectedItem={isResetSelectedItem}
            />
            {modal?.delete && (
                <ModalDelete
                    show={modal?.delete}
                    onHide={() => setShowModal({ delete: false })}
                    description={'Are You Sure to Delete Category Voting?'}
                    totalData={selectedIds?.length}
                    isLoading={isDeleting}
                    onDelete={onDelete}
                />
            )}
            {modal?.form && (
                <FormAwardCategory
                    show={modal?.form}
                    onHideForm={onHideForm}
                    dataAwardCategory={awardCategoryDetail}
                    options={optionsType}
                    isLoading={isCreating || isUpdating}
                    isDisabled={!isFormValid()}
                    onChangeForm={onChangeForm}
                    onSubmit={onSubmit}
                />
            )}
        </div>
    )
}
